<template>
  <div>
    <vs-popup :title="$t(popupTitle)" :active.sync="showModal">
      <form>
        <vs-input
          class="inputx mb-4 mt-1"
          v-model="model.name"
          name="tagName"
          :label="$t('Name')"
          v-validate="'required'"
        />
        <span class="text-danger text-sm" v-show="errors.has('tagName')">{{
          errors.first("tagName")
        }}</span>
        <vs-checkbox v-model="model.isImportant">{{
          $t("ShowInHeader")
        }}</vs-checkbox>
        <br />
        <vs-checkbox v-model="model.isActive" v-if="model.id">{{
          $t("Active")
        }}</vs-checkbox>
        <vs-button
          type="filled"
          class="float-right mb-4"
          @click.prevent="submitForm"
          :diabled="disableSubmit"
          >{{ $t("Save") }}</vs-button
        >
      </form>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { Validator } from "vee-validate";

const dict = {
  custom: {
    tagName: {
      required: "لطفا نام تگ را وارد نمایید.",
    },
  },
};
Validator.localize("fa", dict);
export default {
  name: "Content-management-Tags",
  props: {
    show: { default: false },
    model: {
      default: {},
    },
  },
  data() {
    return {
      tagName: "",
      popupTitle: "",
      disableSubmit: false,
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      createTag: "tag/create",
      updateTag: "tag/update",
    }),
    submitForm() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.disableSubmit = true;
          if (this.model.id != null) {
            this.updateTag(this.model).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ویرایش شد!",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
              this.disableSubmit = false;
            });
          } else {
            this.createTag(this.model).then(() => {
              this.$swal({
                position: "center-center",
                type: "success",
                text: "رکورد مورد‌نظر با موفقیت ثبت شد!",
                showConfirmButton: false,
                timer: 2000,
              });
              this.$emit("finish");
              this.model = {};
              this.$validator.reset();
              this.disableSubmit = false;
            });
          }
        }
      });
    },
  },
  watch: {
    show() {
      if (this.show == true) {
        if (this.model.id) this.popupTitle = "EditTag";
        else this.popupTitle = "CreateNewTag";
      }
      this.$validator.reset();
    },
  },
};
</script>
